var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFuel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 511.999 511.999",
    style: {
      enableBackground: "new 0 0 511.999 511.999"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ff8c01"
    },
    d: "M321.056 473.076V22.774c0-8.232-6.673-14.907-14.907-14.907H62.677c-8.234 0-14.907 6.675-14.907 14.907v450.302h273.286z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e8650c"
    },
    d: "M87.746 7.867H62.677c-8.234 0-14.907 6.675-14.907 14.907v450.302h25.07V22.774c0-8.232 6.672-14.907 14.906-14.907z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#61626d"
    },
    d: "M345.829 504.132H23.995c-8.574 0-15.527-6.951-15.527-15.527s6.953-15.529 15.527-15.529h321.834c8.576 0 15.527 6.953 15.527 15.529s-6.951 15.527-15.527 15.527z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#393a47"
    },
    d: "M345.829 488.604H23.995c-5.743 0-10.747-3.127-13.432-7.763-5.991 10.341 1.502 23.291 13.432 23.291h321.834c11.93 0 19.423-12.949 13.432-23.291-2.685 4.636-7.688 7.763-13.432 7.763z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c8e5fc"
    },
    d: "M264.536 47.618H104.289c-8.232 0-14.907 6.675-14.907 14.907v114.817h190.06V62.524c.001-8.233-6.673-14.906-14.906-14.906z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e0f1fc"
    },
    d: "M264.536 47.618h-71.497c-13.448 41.941-16.803 86.49-10.131 129.724h96.535V62.524c0-8.233-6.674-14.906-14.907-14.906z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffdaa4"
    },
    d: "M193.938 262.071c0 8.232-6.675 14.907-14.907 14.907h-74.742c-8.232 0-14.907-6.675-14.907-14.907v-15.32c0-8.232 6.675-14.907 14.907-14.907h74.742c8.232 0 14.907 6.675 14.907 14.907v15.32z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffc35a"
    },
    d: "M179.031 254.411h-74.742c-6.98 0-12.824-4.804-14.444-11.284-.599 2.399-.462 2.084-.462 18.944 0 8.232 6.675 14.907 14.907 14.907h74.742c8.232 0 14.907-6.675 14.907-14.907v-15.32c0-1.252-.172-2.462-.462-3.624-1.622 6.479-7.466 11.284-14.446 11.284z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8fc8f2"
    },
    d: "M129.253 47.618h-24.965c-8.232 0-14.907 6.675-14.907 14.907v114.817h24.965V62.524c.002-8.233 6.675-14.906 14.907-14.906z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a4a5a4"
    },
    d: "M335.133 239.334h-14.078v45.133h14.078c8.232 0 14.907-6.674 14.907-14.907v-15.32c0-8.232-6.674-14.906-14.907-14.906z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fca84c"
    },
    d: "M504.491 149.274c0 8.233-6.675 14.907-14.907 14.907h-31.469c-8.232 0-14.907-6.674-14.907-14.907V84.056c0-8.232 6.674-14.907 14.907-14.907h31.469c8.232 0 14.907 6.675 14.907 14.907v65.218z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ff8c01"
    },
    d: "M473.849 149.274V84.056c0-8.232 6.675-14.907 14.907-14.907h-30.642c-8.232 0-14.907 6.675-14.907 14.907v65.217c0 8.233 6.674 14.907 14.907 14.907h30.642c-8.232-.001-14.907-6.673-14.907-14.906z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#577ddd"
    },
    d: "m203.436 109.316-14.819-23.152c-1.961-3.066-6.451-3.064-8.41 0l-14.817 23.153c-4.519 7.061-5.019 16.464.015 24.339 8.736 13.659 29.063 14.002 38.015 0l.328-.511c.03-.048.061-.097.09-.146 4.372-7.385 4.219-16.459-.402-23.683z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4369b5"
    },
    d: "M179.961 114.731c5.371-29.365 4.76-28.621 6.947-30.191a4.982 4.982 0 0 0-6.701 1.626l-14.817 23.153c-12.862 20.099 10.246 43.863 31.013 31.296-11.243-2.981-18.602-14.077-16.442-25.884z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#61626d"
    },
    d: "M89.383 175.213v18.744c0 8.232 6.675 14.907 14.907 14.907h160.247c8.232 0 14.907-6.675 14.907-14.907v-18.744H89.383z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333542"
    },
    d: "M114.348 193.957v-18.744H89.383v18.744c0 8.232 6.675 14.907 14.907 14.907h24.965c-8.234-.001-14.907-6.675-14.907-14.907z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#636570"
    },
    d: "M189.658 208.863h74.879c8.232 0 14.907-6.675 14.907-14.907v-18.744H182.6a280.653 280.653 0 0 0 7.058 33.651z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M104.309 231.844c-12.349 0-22.396 10.048-22.396 22.396v15.32c0 12.348 10.047 22.396 22.396 22.396h74.742c12.349 0 22.396-10.048 22.396-22.396v-15.32c0-12.348-10.047-22.396-22.396-22.396h-74.742zm82.158 22.397v15.32c0 4.09-3.327 7.417-7.417 7.417h-74.742c-4.09 0-7.417-3.327-7.417-7.417v-15.32c0-4.09 3.327-7.417 7.417-7.417h74.742c4.09-.001 7.417 3.326 7.417 7.417zM227.908 231.844c-4.137 0-7.489 3.352-7.489 7.489s3.352 7.489 7.489 7.489h51.554c4.137 0 7.489-3.352 7.489-7.489s-3.352-7.489-7.489-7.489h-51.554zM286.952 174.214V62.524c0-12.348-10.048-22.396-22.396-22.396H104.309c-12.348 0-22.396 10.048-22.396 22.396v130.434c0 12.347 10.046 22.396 22.396 22.396 171.64 0 160.85.056 162.533-.116 11.279-1.149 20.109-10.703 20.109-22.28v-18.744zm-22.396 26.161H104.309c-4.09 0-7.417-3.327-7.417-7.417v-11.255h24.548c4.137 0 7.489-3.352 7.489-7.489s-3.352-7.489-7.489-7.489H96.891v-104.2c0-4.09 3.327-7.417 7.417-7.417h160.247c4.09 0 7.417 3.327 7.417 7.417v104.201H147.405c-4.137 0-7.489 3.352-7.489 7.489s3.352 7.489 7.489 7.489h124.568v11.255c0 4.089-3.327 7.416-7.417 7.416z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M489.604 61.66h-8.246V32.711a7.494 7.494 0 0 0-2.772-5.817L447.945 2.051a7.489 7.489 0 0 0-10.534 1.1 7.489 7.489 0 0 0 1.1 10.534l27.867 22.596v25.38h-8.244c-12.348 0-22.396 10.047-22.396 22.396v9.413l-23.798 17.117a7.49 7.49 0 0 0-3.117 6.08v47.515a7.488 7.488 0 0 0 7.489 7.489h50.066v168.026c0 30.001-24.41 54.409-54.415 54.409s-54.415-24.407-54.415-54.409v-67.799c0-.293-.021-.58-.054-.865.074-1.136.054-.106.054-16.792 0-12.348-10.048-22.396-22.396-22.396h-6.589V72.486a7.488 7.488 0 0 0-7.489-7.489 7.488 7.488 0 0 0-7.489 7.489v393.101H55.279V22.774c0-4.09 3.327-7.417 7.417-7.417h243.472c4.09 0 7.417 3.327 7.417 7.417V48.52a7.488 7.488 0 0 0 7.489 7.489 7.488 7.488 0 0 0 7.489-7.489V22.774c0-12.349-10.048-22.396-22.396-22.396H62.696C50.348.378 40.3 10.425 40.3 22.774v442.812H23.016C10.325 465.586 0 475.913 0 488.605c0 12.691 10.325 23.016 23.016 23.016h24.528a7.488 7.488 0 0 0 7.489-7.489 7.488 7.488 0 0 0-7.489-7.489H23.016c-4.432 0-8.038-3.605-8.038-8.038s3.605-8.04 8.038-8.04h323.832c4.432 0 8.038 3.606 8.038 8.04 0 4.432-3.605 8.038-8.038 8.038H73.51a7.488 7.488 0 0 0-7.489 7.489 7.488 7.488 0 0 0 7.489 7.489h273.338c12.691 0 23.016-10.325 23.016-23.016 0-12.692-10.325-23.018-23.016-23.018h-18.283v-173.63c6.908 0 9.638.27 14.005-1.268v49.006c0 38.26 31.13 69.387 69.393 69.387s69.393-31.128 69.393-69.387V171.669h8.246c12.348 0 22.396-10.048 22.396-22.396V84.054C512 71.707 501.952 61.66 489.604 61.66zM335.153 276.977h-6.589v-30.154h6.589c4.09 0 7.417 3.327 7.417 7.417v15.32c.001 4.09-3.327 7.417-7.417 7.417zm88.649-156.474 11.936-8.585c0 40.359-.422 39.969 1.268 44.771h-13.204v-36.186zm34.332 36.187c-4.09 0-7.417-3.327-7.417-7.417V84.055c0-4.09 3.327-7.417 7.417-7.417h31.469c4.09 0 7.417 3.327 7.417 7.417v65.217c0 4.09-3.327 7.417-7.417 7.417h-31.469z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M169.028 147.3s6.444 4.234 15.393 4.248c23.627 0 38.19-26.186 25.343-46.268L190.74 75.556a7.49 7.49 0 0 0-12.616 0l-19.022 29.724c-9.341 14.595-4.398 33.467 9.926 42.02zm2.69-33.945 12.713-19.868 12.715 19.867c8.909 13.925-8.25 30.439-21.946 20.064-5.933-4.576-7.875-13.201-3.482-20.063z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFuel);
export default __webpack_public_path__ + "static/media/fuel.1008683eb30123ce62f5330e488832ca.svg";
export { ForwardRef as ReactComponent };